import classNames from 'classnames';
import LinkWrapper from '../link-wrapper/link-wrapper';

type MainNavLinkNoMenuProps = {
    href: string;
    title: string;
    isActiveSection?: boolean;
    isOpen: boolean;
    onClick: () => void;
    isDark: boolean;
};

export const MainNavLinkNoMenu = (props: MainNavLinkNoMenuProps) => {
    const { href, title, isActiveSection = false, isOpen, onClick, isDark } = props;

    const isOpenActive = isOpen && isActiveSection;

    const textClasses = classNames({
        'text-green-400': isOpenActive,
        'text-white': !isOpenActive && isDark,
        'text-gray-900': !isOpenActive && !isDark,
    });
    const borderClasses = classNames({
        'after:bg-green-400': isOpenActive,
        'after:bg-white': !isOpenActive && isDark,
        'after:bg-gray-900': !isOpenActive && !isDark,
    });

    return (
        <LinkWrapper
            onClick={() => onClick()}
            href={href}
            className={`${isActiveSection ? 'after:w-full' : ''} ${textClasses} ${borderClasses}
                border-b-in
                flex
                font-bold
                font-headline
                items-center
                leading-[1.4]
                mb-0
                no-underline
                text-sm
                tracking-[2.24px]
                uppercase
            `}
        >
            <span className="text-center">{title}</span>
        </LinkWrapper>
    );
};
